export const isValidRegEx = (regEx) => {
    try {
        return Boolean(regEx && new RegExp(regEx));
    }
    catch {
        return false;
    }
};
